import QRCode from "qrcode";

import { useState, useEffect } from "react";
import { IQrCodeProps } from "./QrModal";

export const ScidQrCode = ({ scriptNumber }: IQrCodeProps) => {
  const [qrCode, setQrCode] = useState("");

  useEffect(() => {
    QRCode.toDataURL(scriptNumber!, {width: 300, margin: 0}).then(setQrCode);
  }, [scriptNumber]);

  return <img src={qrCode} alt="qrCode" />;
};
